import { render } from "./CitasTabs.vue?vue&type=template&id=ce85ce50&scoped=true&ts=true"
import script from "./CitasTabs.vue?vue&type=script&lang=ts"
export * from "./CitasTabs.vue?vue&type=script&lang=ts"

import "./CitasTabs.vue?vue&type=style&index=0&id=ce85ce50&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce85ce50"]])

export default __exports__